import React, { useCallback, useEffect, useState } from 'react';
import * as api from '../../billMemory/api';
import { shortDate } from '../../billMemory/core';

/**
 * Invexis admin — Ready to turn on (Fix plan, Fix 4): each source that proved itself, its numbers and the
 * sample greens to look at, with Approve (it goes On at the next night window if it still passes) or Not yet
 * (back to Shadow, its clock restarted).
 */
export default function ReadyList() {
  const [rows, setRows] = useState(null);
  const [msg, setMsg] = useState('');
  const load = useCallback(() => Promise.resolve(api.getReady()).then((r) => setRows((r && r.rows) || [])).catch(() => setRows([])), []);
  useEffect(() => { load(); }, [load]);
  const answer = async (r, verdict) => {
    setMsg('');
    try {
      await api.answerReady(r.business_id, r.source, verdict);
      setMsg(verdict === 'approve' ? `Approved: ${r.business_name} — ${r.words || r.source}.` : `Back to Shadow: ${r.business_name} — ${r.words || r.source}.`);
      await load();
    } catch (e) {
      setMsg((e && e.message) || 'That was refused.');
    }
  };
  return (
    <section className="bm-panel">
      <h3>Ready to turn on</h3>
      {!rows && <div className="bm-note">Loading…</div>}
      {rows && !rows.length && <div className="bm-note">Nothing is waiting.</div>}
      {(rows || []).map((r) => {
        const n = r.numbers || {};
        return (
          <div key={`${r.business_id}-${r.source}`} className="bm-note">
            <div>{`${r.business_name} — ${r.words || r.source}: ${n.greens || 0} greens, ${n.windowWrong || 0} wrong`}</div>
            {r.ready_since && <div>{`Ready since ${shortDate(r.ready_since)}`}</div>}
            <ul className="bm-log">
              {(r.samples || []).map((x) => <li key={x.line_id}>{`${x.printed_name} → ${x.saved_item || '—'}`}</li>)}
            </ul>
            <button type="button" className="irr-secondary-btn" onClick={() => answer(r, 'approve')}>Approve</button>{' '}
            <button type="button" className="irr-secondary-btn" onClick={() => answer(r, 'not-yet')}>Not yet</button>
          </div>
        );
      })}
      {msg && <div className="bm-note">{msg}</div>}
    </section>
  );
}
